import { ColumnSizingState } from '@tanstack/react-table';
import { useCallback } from 'react';
import { useTableStoreValue } from '../TableContext';

export const useInitializeColumnSizing = () => {
  const [table] = useTableStoreValue('table');

  return useCallback(() => {
    if (table.getState().columnSizingInfo.isInitialized) {
      return;
    }

    const { headers } = table.getHeaderGroups()[0];
    const columnSizing: ColumnSizingState = {};

    const tableWrapper = document.getElementById(table.options.name);
    const colgroups = tableWrapper?.getElementsByTagName('colgroup');
    const cols = colgroups
      ? colgroups[colgroups.length - 1]?.getElementsByTagName('col')
      : null;

    if (cols) {
      headers.forEach(({ id }, index) => {
        if (!columnSizing[id] && cols[index]) {
          columnSizing[id] = cols[index].getBoundingClientRect().width;
        }
      });
    }

    tableWrapper?.classList.add('column-sizing-enabled');

    table.setColumnSizing(columnSizing);
    table.setColumnSizingInfo((current) => ({
      ...current,
      isInitialized: true,
    }));
  }, [table]);
};
